// 获取当前日期
const getDate = function getDate() {
	var date = new Date();
	var year = date.getFullYear(); //  返回的是年份
	var month = date.getMonth() + 1; //  返回的月份上个月的月份，记得+1才是当月
	var dates = date.getDate(); //  返回的是几号
	let str = `${year}-${month<10?'0'+month:month}-${dates}`;
	return str;
};
const getNextMonth = function getNextMonth(date) {
	var begindate = new Date(date);
	var end_1 =new Date(begindate.setMonth(begindate.getMonth()+1));
	var end = new Date(end_1.setDate(end_1.getDate()-1));
	var month = "";
	var day = "";
	if((end.getMonth()+1)>=10){
		month = end.getMonth()+1;
	}else{
		month = "0"+(end.getMonth()+1);
	}
	if(end.getDate()>=10){
		day = end.getDate();
	}else{
		day = "0"+(end.getDate());
	}
	return end.getFullYear()+"-"+month+"-"+day;
};
// 判断是否是整数
const isParseInt = function isInteger(n) {
	return parseInt(n) == parseFloat(n);
};
//验证密码必须包含大写字母、小写字母、数字、特殊字符,长度要求15-20位
const testPwd = function isMobile(pwd) {
	return /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{15,20}$/.test(pwd)
}
// 获取当前日期时分秒
const getTime = function getTime() {
	var date = new Date();
	var year = date.getFullYear();
	var month = date.getMonth() + 1; //因为month属性从0开始所以加1
	var day = date.getDate(); // 日
	var week = date.getDay(); // 星期几，是个数字
	var hour = date.getHours();
	var minute = date.getMinutes();
	var second = date.getSeconds();
	second = second < 10 ? "0" + second : second;
	var currentTime = year + "-" + month + "-" + day + " " + " " + hour + ":" + minute + ":" + second;
	return currentTime
}
// 判断手机号码格式
const isMobile = function isMobile(mobile) {
	return /^1[3-9]\d{9}$/.test(mobile)
}

// 身份证格式验证
function cardTest(idNumber) {
  // 校验码位权值
  var weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  // 校验码字符
  var checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
  // 长度校验
  if (idNumber.length !== 18) {
    return false;
  }
  // 数字校验
  if (isNaN(idNumber)) {
    return false;
  }
  // 地址码校验
  var addressCode = idNumber.substring(0, 6);
  if (!/^\d{6}$/.test(addressCode)) {
    return false;
  }
  // 出生日期校验
  var year = parseInt(idNumber.substring(6, 10));
  var month = parseInt(idNumber.substring(10, 12));
  var day = parseInt(idNumber.substring(12, 14));
  if (year < 1900 || year > new Date().getFullYear() - 18 || month < 1 || month > 12 || day < 1 || day > 31) {
    return false;
  }
  var birthday = year + '-' + month + '-' + day;
  if (new Date(birthday).toString() === 'Invalid Date') {
    return false;
  }
  // 校验码计算
  var sum = 0;
  for (var i = 0; i < 17; i++) {
    sum += weight[i] * parseInt(idNumber.charAt(i));
  }
  var mod = sum % 11;
  if (idNumber.charAt(17) !== checkCode[mod]) {
    return false;
  }
  return true;
}

// 加密
const fun_aes = require('../utils/aes.js')
var RSA = require('../utils/wxapp_rsa.js')
//十六位十六进制数作为秘钥
const key = fun_aes.CryptoJS.enc.Utf8.parse("rw9ptc2y3gszxj3d");
//十六位十六进制数作为秘钥偏移量
const iv = fun_aes.CryptoJS.enc.Utf8.parse('dg93rvmqu8nrfu88');
// RSA签名私钥
var privateKey_pkcs8 ='-----BEGIN PRIVATE KEY-----MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBALt2yY6SmshIEFlpbuepE0GQd3K8OrfI+v99PKh/TeCTYXBDZxkFs0vZDlYw2/oFIDDr5Q/SdlUfYoExUzZikfx1P52/bnxFE2b6WBrVRAiKt/Y4Smky5woxoUngoERJw2Ek5vecIFxXncVOFFwOsWtSYgsUCW61EMLWyDVl7ju/AgMBAAECgYBGPCkj+5V2OFm3xiLBNL18MQ4vtIojVW+EzX0ufBPHcjBtiTNVUqdsYXRXopKoR8dZzOfTV7zyA4I6eSp+E8wxr14q2bx+DRmt4kInt0j8ZyFJermyz2BqX/zl95sugAMULoomb4GFrfHjtResDZyG2LwgFXTG1/yZfn2ri88fEQJBAO3eXbud8N2IBZZqy+A2iUxGBsVtdSFxmlm0HlZm3yNV5l8vTYDmo+mknXsjJZgYPghtMbAvIu1Y71hVwcx4pXUCQQDJwNqs2QiVUUFyGx7bhcZOa8G9sEsSh79eaJfxuLdgwU13BL6A0R1L19Ecc7al4neHmw1Lh8K7m954uLOZg9HjAkBSjNFKw01MFGCcCwQmE8ciSUsgSRRVPu+qIfBFW/4kbTM95VSoX2KTOyXMDi6F0iP1GLAdzL36UNr/dQOEynnhAkBoDIz6jafOkixlc7UzU8eVFB/D+1KMSPQZ9Wk/YZs5TBfuZMT23GH2hmQy/z5YSPaKOh3eMTLt3JIcwmzlpEUvAkEApp7GmFQNgMifsz/e+7z0C9fNyQimshH1bQ3pEeFHYuqTjNkw3B7ojAMrnNIlLbo/TOOWgjYR97Sv0Ywo8LAKOA==-----END PRIVATE KEY-----'
const encryptBASE64 = n => {
	var srcs1 = fun_aes.CryptoJS.enc.Utf8.parse(n);
	var encrypted1 = fun_aes.CryptoJS.AES.encrypt(srcs1, key, {
		iv: iv,
		mode: fun_aes.CryptoJS.mode.CBC,
		padding: fun_aes.CryptoJS.pad.Pkcs7
	});
	//返回base64加密结果
	return encrypted1.toString();
}

const decrypt = data => {
	// data是base64编码数据
	var decrypt = fun_aes.CryptoJS.AES.decrypt(data, key, {
		iv: iv,
		mode: fun_aes.CryptoJS.mode.CBC,
		padding: fun_aes.CryptoJS.pad.Pkcs7
	});
	var decryptedStr = decrypt.toString(fun_aes.CryptoJS.enc.Utf8);
	return decryptedStr.toString();
}

// 加签名
const autograph = data => {
	// 加签,data是加密后的数据
	var sign_rsa = new RSA.RSAKey();
	sign_rsa = RSA.KEYUTIL.getKey(privateKey_pkcs8);
	// console.log('签名RSA:')
	// console.log(sign_rsa)
	var hashAlg = 'sha1';
	var hSig = sign_rsa.signString(data, hashAlg);
	hSig = RSA.hex2b64(hSig); // hex 转 b64
	// console.log("签名结果：" + hSig)
	return hSig
}

export default {
	getDate,
	isParseInt,
	testPwd,
	getTime,
	isMobile,
	cardTest,
	encryptBASE64,
	decrypt,
	autograph,
	getNextMonth,
};
